@if (displayFooter()) {
  <ion-footer class="new_version">
    <ion-toolbar class="footer_version">
      <div (click)="openReleaseNotePage()" class="details_version">
        <ion-icon class="icon_checkmark" name="checkmark-circle"></ion-icon>
        <span class="title large">{{ 'AIDE.APP_UPDATED' | translate }}</span>
        <span class="title small">{{ 'AIDE.APP_UPDATED_SMALL' | translate }}</span>
        <span class="version">{{ version }}</span>
        <ion-icon class="icon_open" name="open-outline"></ion-icon>
      </div>
      <ion-icon (click)="closeFooter()" class="icon_close" name="close"></ion-icon>
    </ion-toolbar>
  </ion-footer>
}
